import React, { useEffect, useState } from 'react';
import { Breadcrumb, Layout, theme, Row, Col, Form, Button, Modal, Select, Input, Spin ,Image, Typography, Table, Card, Tag, Space, Switch, Tooltip, Popconfirm } from 'antd';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Headerdiv from "../layout/header.js";
import Footerdiv from "../layout/footer.js";
import { useNavigate } from "react-router-dom";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../usableclasses.js';
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;


function Segment() {
    const ApiURL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");
    const { token: { colorBgContainer, borderRadiusLG }, } = theme.useToken();

   
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [form] = Form.useForm();
    const [segments, setSegments] = useState([]);
    const [filteredSegments, setFilteredSegments] = useState([]);
    const [keyword, setKeyword] = useState("");
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editSegment, setEditSegment] = useState(null);
    const [selectedSegment, setSelectedSegment] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchSegments();
    }, []);

    const fetchSegments = async () => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.get(`${ApiURL}/master/segment/all`, { headers });
            setSegments(response.data);
            setFilteredSegments(response.data);
        } catch (error) {
            AlertError("Failed to fetch Segments");
        } finally {
            setLoading(false);
        }
    };

 
    const showModal = () => {
        setIsModalOpen(true);
    };
    const showEditModal = (segment) => {
     
        setEditSegment(segment);
        form.setFieldsValue({
           // ProductTypeCode: ProductType.ProductTypeCode,
            segmentName: segment.segmentName,
            segmentActiveStatus: segment.segmentActiveStatus === true,
        });
        setIsEditModalOpen(true);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsEditModalOpen(false);
        form.resetFields();
    };

    
    const handleCreateSegment = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();

            const requestData = {
                segmentName: values.segmentName,
            };

            const headers = {
                SystemAccessToken: TOKEN,
                "Content-Type": "application/json",
            };

            const response = await axios.post(
                `${ApiURL}/master/segment/create`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Segment successfully added!");
                handleCancel();
                fetchSegments();
            }
        } catch (error) {
            AlertError(error.response?.data?.message || "Failed to add Segment!");
        }finally {
            setLoading(false);
        }
    };
    const handleUpdateSegment = async () => {
        setLoading(true);
        try {
            const values = await form.validateFields();
            const requestData = {
                segmentId: editSegment.segmentId,
                segmentName: values.segmentName,
                segmentActiveStatus: values.segmentActiveStatus,
            };

            const headers = { SystemAccessToken: TOKEN };
            const response = await axios.post(
                `${ApiURL}/master/segment/edit`,
                requestData,
                { headers }
            );

            if (response.status === 200) {
                AlertSuccess("Segment successfully updated!");
                handleCancel();
                fetchSegments();
            }
        } catch (error) {
            console.log(error);
            AlertError(error.response?.data?.message || "Failed to update Segment!");
        }finally {
            setLoading(false);
        }
    };

    const handleDeleteSegment = async (id) => {
        setLoading(true);
        try {
            const headers = { SystemAccessToken: TOKEN };
            await axios.get(`${ApiURL}/master/segment/delete/${id}`, { headers });
            AlertSuccess("Segment deleted successfully!");
            fetchSegments();
        } catch (error) {
            AlertError("Failed to delete Segment!");
        }finally {
            setLoading(false);
        }
    };

    const handleFilter = () => {
        setLoading(true);
        let filtered = segments;

        if (selectedSegment) {
            filtered = filtered.filter(segment => segment.segmentId === selectedSegment);
        }

        if (keyword) {
            filtered = filtered.filter(segment => segment.segmentId.toLowerCase().includes(keyword.toLowerCase()));
        }

        setFilteredSegments(filtered);
       
     setLoading(false);
        
    };

   
    const handleReset = () => {
        setLoading(true);
        setKeyword('');
        setSelectedSegment(null);
        setFilteredSegments(segments);
        setLoading(false);
    };

    const columns = [
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            fixed: 'left',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit">
                        <Button type="link" icon={<EditOutlined />} onClick={() => showEditModal(record)} />
                    </Tooltip>
                    <Popconfirm
                        title="Are you sure to delete this Segment?"
                        onConfirm={() => handleDeleteSegment(record.segmentId)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Tooltip title="Delete">
                            <Button type="link" danger icon={<DeleteOutlined />} />
                        </Tooltip>
                    </Popconfirm>
                </Space>
            ),
        },
        {
            title: 'Segment Name',
            dataIndex: 'segmentName',
            key: 'segmentName',
            sorter: (a, b) => a.segmentName.localeCompare(b.segmentName),
            align: "center",
        },
        {
            title: 'Status',
            dataIndex: 'segmentActiveStatus',
            key: 'segmentActiveStatus',
            render: (segmentActiveStatus) => (
                <Tag color={segmentActiveStatus === true ? "green" : "red"}>
                    {segmentActiveStatus === true ? "Active" : "Inactive"}
                </Tag>
            ),
            align: "center",
        },
    ];
    return (
        <Spin spinning={loading} tip="Processing...">
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>Master</Breadcrumb.Item>
                    <Breadcrumb.Item>Segments</Breadcrumb.Item>
                </Breadcrumb>
                <div style={{ padding: 10, minHeight: '65vh', background: colorBgContainer, borderRadius: borderRadiusLG, }} >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row>
                            <Col xs={24} style={{ textAlign: "right",marginBottom:'10px' }}>
                                <Button type="primary" onClick={showModal}>Create New</Button>
                            </Col>

                        </Row>
                        
                        <Typography.Title level={5}>List of Segment</Typography.Title>
                        <Table
                            columns={columns}
                            dataSource={filteredSegments}
                            rowKey="segmentId"
                            pagination={{ pageSize: 5 }}
                            scroll={{ x: 600 }}
                        />

                    </Space>
                </div>
            </Content>
            <Footerdiv />
            <Modal
                title="Create New Segment"
                open={isModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>,
                    <Button key="create" type="primary" onClick={handleCreateSegment}>
                        Create
                    </Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[
                            { required: true, message: "ProductType code is required" },
                            { len: 4, message: "ProductType code must be exactly 4 characters" },
                        ]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}

                    <Form.Item
                        label="Segment Name"
                        name="segmentName"
                        rules={[{ required: true, message: "Segment name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>

            <Modal
                title="Edit Segment"
                open={isEditModalOpen}
                onCancel={handleCancel}
                footer={[
                    <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
                    <Button key="update" type="primary" onClick={handleUpdateSegment}>Update</Button>,
                ]}
            >
                <Form form={form} layout="vertical">
                    {/* <Form.Item
                        label="ProductType Code"
                        name="ProductTypeCode"
                        rules={[{ required: true, message: "ProductType code is required" }, { len: 4, message: "ProductType code must be exactly 4 characters" }]}
                    >
                        <Input maxLength={4} />
                    </Form.Item> */}
                    <Form.Item
                        label="Segment Name"
                        name="segmentName"
                        rules={[{ required: true, message: "Segment name is required" }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label="Segment Status"
                        name="segmentActiveStatus"
                        valuePropName="checked"
                    >
                        <Switch defaultChecked={editSegment?.selectedSegment?.segmentActiveStatus === true} />
                    </Form.Item>
                </Form>
            </Modal>
            
        </Layout>
        </Spin>
    );
}

export default Segment;